import { useQuery } from '@tanstack/react-query';
import { useHostContext } from '../useHostContext';
import { unleashQueries } from 'src/core/services/featureToggles/queries';
export function useUnleash(name) {
    const userId = useHostContext().user.id;
    const query = useQuery(unleashQueries.getStatus(name, userId));
    return query.data ?? false;
}
